export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "result_count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("count")), " results for \"", _interpolate(_named("keyword")), "\""])},
      "by_category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["By Category"])},
      "all_categories": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All Categories"])}
    }
  })
}
